import { Component } from "@angular/core";
import { ICellRendererAngularComp } from "ag-grid-angular";
import { ICellRendererParams } from "ag-grid-community";
import { GridTooltipCellModel } from "./grid-tooltip-cell.model";
@Component({
    selector: "kno2-grid-tooltip-cell-renderer",
    templateUrl: "./grid-tooltip-cell-renderer.component.html",
    standalone: false
})
export class GridTooltipCellRendererComponent implements ICellRendererAngularComp {
    public cellContent: string;
    public tooltipText: string;

    public refresh(params: ICellRendererParams): boolean {
        return false;
    }
    public agInit(params: ICellRendererParams & GridTooltipCellModel): void {
        this.cellContent = params.cellContent || params.value || "N/A";
        this.tooltipText = params.tooltipText || this.cellContent;
    }
}
